import {Component, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ArticleDto, BasketArticleDto} from '@shared/service-proxies/service-proxies';
import {AppComponentBase} from '@shared/common/app-component-base';
import {AppConsts} from '@shared/AppConsts';
import {WebshopService} from '@app/shared/common/shop-system/services/webshop.service';

import _ from 'lodash-es';
import {DataViewService} from '@app/webshop/shared/services/data-view.service';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { BasePermissionDefinition } from '@shared/permission/base-permission-definition';

@Component({
    selector: 'webshopItemDetails',
    templateUrl: './webshop-item-details-modal.component.html',
    styleUrls: ['webshop-item-details-modal.component.less']
})
export class WebshopItemDetailsModalComponent extends AppComponentBase implements OnInit, OnDestroy {
    protected readonly BasePermissionDefinition = BasePermissionDefinition;

    private _dataViewService: DataViewService;

    @ViewChild('webshopItemDetails', {static: true}) modal: ModalDirective;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    @Output() addItemToBasket: EventEmitter<any> = new EventEmitter<any>();
    saving = false;
    active = false;
    selectedItems: BasketArticleDto;
    deficiteItems = 0;
    availableAmount = 0;
    showAvailableAmount = false;
    private currentTemplate$: Observable<string>;

    protected readonly destroy$ = new Subject<void>();

    // Selected template value
    selectedTemplate: string | null = 'theme1'; // Default is no selection 'legacy'; //

    constructor(
        injector: Injector,
        private _webshopService: WebshopService
    ) {
        super(injector);

        this._dataViewService = injector.get(DataViewService);

        this.currentTemplate$ = this._dataViewService.currentTemplate$;
    }

    private _deficiteWaitingTime = '';

    get deficiteWaitingTime(): string {
        return this._deficiteWaitingTime;
    }

    set deficiteWaitingTime(time: string) {
        this._deficiteWaitingTime = time;
    }

    ngOnInit(): void {
        this.currentTemplate$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe((template) => {
                this.selectedTemplate = template;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    show(item: any): void {
        this.active = true;
        if (item) {
            this.selectedItems = item.data ?? item;

            //TODO: set deficite time, remove after finishing backend
            //this.deficiteWaitingTime = this._getDeficiteWaitingTime();

            this.calculateAvailable();
        }

        this.modal.show();
    }

    calculateAvailable() {
        this.availableAmount = this._getAmountOfAvailableItems();

        this.deficiteItems = (this.selectedItems.quantity - this.selectedItems.availableAmount);

        this.deficiteWaitingTime = this._getDeficiteWaitingTime();
    }

    onShown() {

    }

    hide() {
        this.modal.hide();
    }

    open() {
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.saving = false;
        this.deficiteItems = 0;
        this.showAvailableAmount = true;
        this.resetQuantity(this.selectedItems);

        this.modal.hide();
    }

    onAddUserGroups($event) {
        this.selectedItems = $event;
    }

    onSave() {
        this.saving = true;
        this.addItemToBasket.emit(this.selectedItems);
        this.resetQuantity(this.selectedItems);
        this.close();
    }

    addToBasket(article: BasketArticleDto) {
        this.selectedItems.quantity = article.quantity;
        this.onSave();
    }

    addToFavorite($event: Event, product: ArticleDto) {
        this.preventClick($event);

        this._webshopService.addToFavorite($event, product);
    }

    preventClick($event: Event) {
        $event.stopPropagation();
    }

    //#region Favorites

    showFavorites() {
        this._webshopService.showFavorites();
    }

    isStockAvailable(articleDto: any): boolean {
        if (articleDto.availableAmount > 0) {
            return false;
        }

        return true;
    }

    isGapAvailable(articleDto: any): boolean {
        if (articleDto.availableAmount > 0) {
            return true;
        }

        return false;
    }

    //#endregion Favorites

    private _getAmountOfAvailableItems(): number {
        if (this.selectedItems.quantity >= 1) {
            this.showAvailableAmount = true;
        } else {
            this.showAvailableAmount = false;
        }

        let amount = this.selectedItems.stockAmount;
        //TODO: when permission available we need to do this dynamic
        amount = this.selectedItems.availableAmount;

        if (this.selectedItems.quantity <= this.selectedItems.availableAmount) {
            return this.selectedItems.quantity;
        } else if (this.selectedItems.quantity > this.selectedItems.availableAmount) {
            return this.selectedItems.availableAmount;
        }

        return 0;
    }

    private _getDeficiteWaitingTime(): string {
        return ` < ${_.random(2, 4)}`;
    }


    isCategoriesAvailable(article: BasketArticleDto): boolean {
        return article.categories && article.categories.length > 0;
    }
}
